import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CCardFooter,
  CLink,
  CButton
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import SearchModal from "./search";
import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./styles.css";

class RoomMe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rooms: [],
      loading: true,
      searchModal: false
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleRooms();
  }

  handleRooms() {
    axios
      .get(
        `${URL.api}community/room/listByUser?class=false&user=${this.props.user.user.id}`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ rooms: resp.data.data, loading: false });
        },
        error => {
          this.error(
            "Não foi possível carregar as comunidades. Tente novamente"
          );
        }
      );
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <SearchModal
          show={this.state.searchModal}
          onClose={() => this.setState({ searchModal: false })}
          mine={this.state.rooms}
          onUpdateRooms={() => this.handleRooms()}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">Comunidades</h4>
                <div className="small text-muted">
                  Veja as comunidades que você participa
                </div>
              </div>
              <CButton
                color="primary"
                className="text"
                onClick={() => this.setState({ searchModal: true })}
              >
                <i className="fa fa-search"></i>
              </CButton>
            </CCardHeader>
            <CCardBody className="pb-1">
              <CRow>
                {this.state.rooms.filter(room => room.authorized === true)
                  .length > 0 ? (
                  this.state.rooms
                    .filter(room => room.authorized === true)
                    .map((room, idx) => (
                      <CCol sm="4" lg="3" className="mb-3" key={idx}>
                        <CCard className="card-room">
                          <CCardHeader
                            className="bg-primary d-flex justify-content-end flex-column"
                            style={{ height: "120px" }}
                          >
                            <CLink
                              to={`/room/${room.id}`}
                              className="text-white"
                            >
                              <h4
                                className="card-title mb-2 text-ellipsis"
                                title={room.name}
                              >
                                {room.name}
                              </h4>
                            </CLink>
                            <div
                              className="small text-ellipsis"
                              style={{ opacity: 0.6 }}
                            >
                              {room.external_id && (
                                <>
                                  <i className="fa fa-graduation-cap mr-2"></i>
                                  {room.external_id}
                                  <span
                                    className="mx-2"
                                    style={{ opacity: 0.4 }}
                                  >
                                    ·
                                  </span>
                                </>
                              )}
                              <i className="fa fa-group mr-2"></i>
                              Comunidade
                            </div>
                          </CCardHeader>
                          <CCardBody>
                            <div className="text-muted small card-list">
                              {" "}
                              <span className="mr-3" style={{ flex: 1 }}></span>
                              <span></span>
                            </div>
                            <div className="text-muted small card-list">
                              {" "}
                              <span className="mr-3" style={{ flex: 1 }}></span>
                              <span></span>
                            </div>
                            <div className="text-muted small card-list">
                              {" "}
                              <span className="mr-3" style={{ flex: 1 }}></span>
                              <span></span>
                            </div>
                          </CCardBody>
                          <CCardFooter className="d-flex text-muted">
                            <span className="mr-3" style={{ flex: 1 }}>
                              <i className="fa fa-user mr-2"></i>{" "}
                              {room.num_users}
                            </span>
                            <CLink to={`/room/${room.id}/docs`}>
                              <i className="fa fa-folder text-muted card-icon"></i>
                            </CLink>
                          </CCardFooter>
                        </CCard>
                      </CCol>
                    ))
                ) : (
                  <div className="p-3 mb-3 text-center w-100 text-muted">
                    Você não está participando de nenhuma comunidade
                  </div>
                )}
              </CRow>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomMe);
